const capitalize = (string: string, onlyFirst?: boolean) => {
  if (onlyFirst) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  return string
    .split(' ')
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export default capitalize



// WEBPACK FOOTER //
// ./src/utils/capitalize/capitalize.ts